import React, { createContext, useContext } from 'react';
import { useNativeHealthKit, UseNativeHealthKitReturn } from '@/hooks/useNativeHealthKit';

const NativeHealthKitContext = createContext<UseNativeHealthKitReturn | null>(null);

export function NativeHealthKitProvider({ children }: { children: React.ReactNode }) {
  const healthKit = useNativeHealthKit();
  return (
    <NativeHealthKitContext.Provider value={healthKit}>
      {children}
    </NativeHealthKitContext.Provider>
  );
}

export function useSharedHealthKit(): UseNativeHealthKitReturn {
  const context = useContext(NativeHealthKitContext);
  if (!context) {
    throw new Error('useSharedHealthKit must be used within NativeHealthKitProvider');
  }
  return context;
}
